import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import Loading from "../common/loading";
import { backofficeLinks } from "@/components/lib/SidebarLinks";

export default function CreateDrinksSkeleton( {links=backofficeLinks} ) {
  return (
   <Loading links={links} >
     <div className="py-5 container">
      {/* Stepper Skeleton */}
      <div className="flex items-center justify-between mb-10 max-w-screen-md mx-auto">
        {[1, 2, 3].map((_, idx) => (
          <div key={idx} className="flex-1">
            <Skeleton className="h-4 w-20 mx-auto bg-cblack6" />
            {idx < 3 && <div className="h-1 w-full bg-cblack6 my-2"></div>}
          </div>
        ))}
      </div>

      <Card className="max-w-screen-md bg-cblack4 mx-auto text-cwhite">
        <CardHeader>
          <CardTitle>
            <Skeleton className="h-6 w-48 bg-cblack6" />
          </CardTitle>
        </CardHeader>

        <CardContent>
          <div className="flex flex-col gap-6">
            {/* Item No */}
            <div className="space-y-2">
              <Skeleton className="h-5 w-24 bg-cblack6" />
              <Skeleton className="h-10 w-full bg-cblack6" />
            </div>

            {/* Name */}
            <div className="space-y-2">
              <Skeleton className="h-5 w-20 bg-cblack6" />
              <Skeleton className="h-10 w-full bg-cblack6" />
            </div>

            {/* Description */}
            <div className="space-y-2">
              <Skeleton className="h-5 w-28 bg-cblack6" />
              <Skeleton className="h-10 w-full bg-cblack6" />
            </div>


            {/* Brand */}
            <div className="space-y-2">
              <Skeleton className="h-5 w-24 bg-cblack6" />
              <div className="flex items-end gap-4">
                <Skeleton className="h-10 w-full flex-1 bg-cblack6" />
                <Skeleton className="h-10 w-32 bg-cblack6" />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Footer Buttons */}
      <div className="flex justify-between items-center gap-5 max-w-screen-md mx-auto mt-5">
        <Skeleton className="h-10 w-full bg-cblack6" />
        <Skeleton className="h-10 w-full bg-cblack6" />
        <Skeleton className="h-10 w-full bg-cblack6" />
      </div>
    </div>
   </Loading>
  );
}
